import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import styles from './screen-reader-text.module.scss.js';

const ScreenReaderText = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (jsx("span", Object.assign({ className: styles.screenReaderText }, rest, { children: children })));
};

export { ScreenReaderText as default };
